var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifyRrr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.593 4.91804C4.593 4.43487 5.01109 4.14626 5.71173 4.14626C6.63824 4.14626 7.47041 4.5485 8.23543 5.03237L9.15961 2.62089C8.43199 2.15728 7.6282 1.81539 6.7691 1.69869L6.76876 0H4.31075V1.85173C2.73213 2.31939 1.72327 3.58443 1.72327 5.12093C1.72327 7.14598 3.37302 8.05903 4.9847 8.68413C6.30473 9.21214 6.48677 9.65924 6.48677 10.0635C6.48677 10.637 5.93516 11.0375 5.14551 11.0375C4.08374 11.0375 3.15956 10.5382 2.32135 9.93562L1.43359 12.3831C2.25528 12.991 3.16931 13.3757 4.19095 13.5075V15.2679H6.66613V13.3649C8.29361 12.8777 9.37359 11.5247 9.37359 9.94468C9.37359 8.2005 8.45045 7.08479 6.28678 6.21455C4.71048 5.56988 4.59283 5.2826 4.59283 4.91783L4.593 4.91804Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31882 19.7511L2.09709 16.5294L1 17.6187L5.31882 21.9376L14.59 12.6664L13.5006 11.577L5.31882 19.7511Z",
    fill: "#ECF9EE",
    stroke: "#ECF9EE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyRrr);
export default __webpack_public_path__ + "static/media/verify-rrr.dbade22bf63f785c5202d8aaa291352b.svg";
export { ForwardRef as ReactComponent };